import { render, staticRenderFns } from "./ItemStrip.vue?vue&type=template&id=31e7b0a8&scoped=true&lang=pug&"
import script from "./ItemStrip.vue?vue&type=script&lang=js&"
export * from "./ItemStrip.vue?vue&type=script&lang=js&"
import style0 from "./ItemStrip.vue?vue&type=style&index=0&id=31e7b0a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e7b0a8",
  null
  
)

component.options.__file = "ItemStrip.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
installComponents(component, {
  VDivider,
  VFlex,
  VLayout,
  VListTile,
})
